import { Translation } from '@ps/web-shared-components';
import { StarsInfo } from '@ps/web-shared-ui';
import React from 'react';

import { styles as sharedStyles } from '@swf/account';

import SuccessResponseMessage from '../SuccessResponseMessage/SuccessResponseMessage';

import { TXTWCL_SorryX_you_must_verify_your_id_ELL } from './AddressFormNotificationHandler.messages.json';

interface Props {
  submitSucceeded: boolean;
  isMitIdRequired: boolean;
  mitIdError: boolean;
  submitError?: React.ReactElement;
}

const AddressFormNotificationHandler: React.FC<Props> = ({
  submitSucceeded,
  isMitIdRequired,
  mitIdError,
  submitError
}) => {
  if (mitIdError)
    return (
      <StarsInfo type="error" className={sharedStyles.message}>
        <Translation {...TXTWCL_SorryX_you_must_verify_your_id_ELL} />
      </StarsInfo>
    );
  else if (submitSucceeded && !isMitIdRequired) return <SuccessResponseMessage />;
  else return submitError || null;
};

export default AddressFormNotificationHandler;
